import Backbone from 'backbone';
import Radio from 'backbone.radio';
import MFALoginView from '@/views/mfa/mfa_login_view';

var globalCh = Radio.channel('global');
var routerCh = Radio.channel('router');

export default function show_mfa_login(token) {
    var controller = globalCh.request('controller');
    var options = globalCh.request('app_options');
    var next = Backbone.history.location.pathname;
    
    if (window.location.search === '?next=forums') {
        next = 'https://forums.electricimp.com';
    }
    if (next.indexOf('/login') > -1) next = '/ide';


    if (options.theme && options.theme.app_title) {
        document.title = options.theme.app_title + " Login";
    } else {
        document.title = "Electric Imp Login";
    }

    var app_layout = controller.ensure_login_layout();
    app_layout.showChildView('content', new MFALoginView({
        model: new Backbone.Model(),
        next: next,
        token: token,
    }));
    routerCh.request('set_location', 'login');
}